(() => {
  const locale=document.documentElement.lang.toLowerCase();
  const code=({'zh-cn':'zh-CN','zh-hans':'zh-CN','pt-pt':'pt'}[locale]||locale.split('-')[0]);
  const searchLabel=window.USFLanguageSeeds?.[code]?.Search||'Search';
  function enhance(){
    for(const form of document.querySelectorAll('form[id*="localization_language_form"]')){
      if(form.dataset.usfLanguagesReady)continue;
      const list=form.querySelector('ul');
      if(!list||!list.querySelector('a[data-value][lang]'))continue;
      form.dataset.usfLanguagesReady='true';form.classList.add('usf-language-list-form');
      const input=document.createElement('input');input.type='search';input.className='usf-language-search notranslate';input.placeholder=searchLabel;input.setAttribute('aria-label',searchLabel);input.setAttribute('translate','no');input.autocomplete='off';
      input.addEventListener('input',()=>{const value=input.value.normalize('NFD').replace(/\p{Diacritic}/gu,'').toLowerCase().trim();for(const item of list.children){const link=item.querySelector('a[lang]');const text=(item.textContent+' '+(link?.lang||'')).normalize('NFD').replace(/\p{Diacritic}/gu,'').toLowerCase();item.hidden=!!value&&!text.includes(value);}});
      input.addEventListener('keydown',event=>{if(event.key==='Enter')event.preventDefault();});
      list.before(input);
    }
  }
  function boot(){enhance();let timer;new MutationObserver(()=>{clearTimeout(timer);timer=setTimeout(enhance,50);}).observe(document.body,{childList:true,subtree:true});}
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',boot,{once:true}):boot();
})();
